<script setup>

const props = defineProps({
  item: {
    type: Object,
  }
})

const publishedDate = ref(new Date(props.item.attrs.published))
const dispayDate = ref(`${publishedDate.value.getDate()}. ${publishedDate.value.getMonth() + 1}. ${publishedDate.value.getFullYear()}`)

</script>

<template>
	<div class="lg:grid grid-cols-12 gap-8 dark:text-light items-start lg:border-l dark:border-light dark:border-opacity-30 py-6 lg:py-10">
		<div class="col-span-2">
			<span class="text-base xl:text-lg fvs600 pl-6 date whitespace-nowrap mb-6 lg:mb-0 lg:pt-1.5">{{ dispayDate }}</span>
		</div>
		<div class="col-span-10 2xl:col-span-8">
			<div class="lg:flex items-start">
				<!-- <div v-if="item.attrs.image" class="aspect-square flex-shrink-0 w-[280px] lg:mr-10 mb-6 lg:mb-0" :style="{ backgroundImage: `url(${item.attrs.image?.url})` }">

				</div> -->
				<Placeholder flex class="flex-shrink-0 lg:mr-10 mb-6 lg:mb-0">
					<NuxtImg preload class="w-full grow-0 lg:mt-1.5" :src="item.attrs.image?.url" />
				</Placeholder>
				<div>
					<h4 class="text-red mb-4">{{ item.attrs.title }}</h4>
					<div class="text-base xl:text-lg leading-[140%]" v-html="item.attrs.content" />
					<Button v-if="item.attrs.album" class="mt-4" type="transparent" :to="item.attrs.album.attrs.url" target isSmall>{{ $t('album.buy') }}</Button>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>

	.date {
		display: inline-block;
		position: relative;

		&::before {
			position: absolute;
			left: -5px;
			top: 6px;
			content: '';
			width: 9px;
			height: 9px;
			border-radius: 100%;
			background-color: theme('colors.light');

			.light & {
				background-color: theme('colors.dark');
			}
		}
	}

</style>